import React from 'react'
import clsx from 'clsx'
import styles from './UIGamePlayerInfoSectionImageWithCount.module.scss'
import {type ImageURL} from '@colonist/types'

interface UIGamePlayerInfoSectionImageWithCountProps {
    piece: ImageURL
    count: number
    size?: 'md' | 'sm'
    bold?: boolean
}

export const UIGamePlayerInfoSectionImageWithCount = ({
    piece,
    count,
    size = 'md',
    bold,
}: UIGamePlayerInfoSectionImageWithCountProps) => (
    <div className={styles.container}>
        <img className={styles.image} src={piece} />
        <span className={clsx(styles.count, {
            [styles.sm]: size === 'sm',
            [styles.bold]: bold,
        })}>{count}</span>
    </div>
)
